import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'mb-view-multi-value-dialog',
  templateUrl: './view-multi-value-dialog.component.html',
})
export class ViewMultiValueDialogComponent {

  @Input() modalData: any
  @Input() modalTitle: string | undefined

  constructor (public activeModal: NgbActiveModal) {
  }
}
